module.exports = __webpack_public_path__ + "img/4-6.3f9f9451.png";